import React, { Component } from "react";
import { Table, Button, Message, Label } from "semantic-ui-react";

class PassportExpiryPrintReport extends Component {
  render() {
    
    const { transactions,total } = this.props;
    return (
        <Table celled fixed singleLine>
        <Table.Header>

        <Table.Row>
          <Table.HeaderCell colSpan="5" style={{ textAlign:"center" }}>Passport Expiry Report</Table.HeaderCell>
        </Table.Row>

          
            <Table.Row>
                <Table.HeaderCell width={1} style={{ textAlign:'center' }}>Sr</Table.HeaderCell>
                <Table.HeaderCell width={5}>Name</Table.HeaderCell>
                <Table.HeaderCell width={5}>Company</Table.HeaderCell>
                <Table.HeaderCell width={3}>Mobile</Table.HeaderCell>
                <Table.HeaderCell width={3}>Passport</Table.HeaderCell>
                <Table.HeaderCell width={3} style={{ textAlign:'center' }}>Expiry Date</Table.HeaderCell>
              </Table.Row>
        </Table.Header>

        <Table.Body>
          {transactions.map(transaction => (
            <Table.Row>
              <Table.Cell style={{ textAlign:'center' }}>{transaction.sr}</Table.Cell>
              <Table.Cell>{transaction.name}</Table.Cell>
              <Table.Cell style={{ whiteSpace: 'pre-line' }}>{transaction.company}</Table.Cell>
              <Table.Cell>{transaction.mobile}</Table.Cell>
              <Table.Cell>{transaction.passport}</Table.Cell>
              <Table.Cell style={{ textAlign:'center' }}>{transaction.passport_expiry_date}</Table.Cell>
            </Table.Row>
            )
          )}

            {/* <Table.Row>
              <Table.Cell style={{ textAlign:"center" }}></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell style={{ textAlign:"center" }}></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell colspan="3" style={{ textAlign:"left",fontSize:'15px' }}><b>{total}</b></Table.Cell>
             
            </Table.Row> */}

        </Table.Body>
      </Table>
    );
  }
}
export default PassportExpiryPrintReport;
